export default "/assets/images/graph-pm-sm.5b85e869ac2511bc.png";